import { InvestmentObjective } from '../../AccountOpening.meta';

export const investmentObjectiveOptions = [
  {
    label: 'Growth',
    value: InvestmentObjective.Growth,
  },
  {
    label: 'Income',
    value: InvestmentObjective.Income,
  },
  {
    label: 'Capital Preservation',
    value: InvestmentObjective.CapitalPreservation,
  },
  {
    label: 'Speculation',
    value: InvestmentObjective.Speculation,
  },
  {
    label: 'Other',
    value: InvestmentObjective.Other,
  },
];
